import PropTypes from 'prop-types';
import React from 'react';
import Loader from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import { Centro, Linha, Interno } from '../../styles/base';

const GeraDiaDaSemana = (dia) => {
  if (dia === '1') {
    return 'Segunda-Feira';
  }
  if (dia === '2') {
    return 'Terça-Feira';
  }
  if (dia === '3') {
    return 'Quarta-Feira';
  }
  if (dia === '4') {
    return 'Quinta-Feira';
  }
  if (dia === '5') {
    return 'Sexta-Feira';
  }
  if (dia === '6') {
    return 'Sábado';
  }
  if (dia === '7') {
    return 'Domingo';
  }
  return '';
};

const CardColetaDeLixo = ({
  diaSemana, enderecoAte, enderecoDe, horario, html,
}) => (
  <div>
    {(diaSemana) && (
      <p>
        <span style={{ fontWeight: 'bolder' }}>Dia da Semana:</span>
        {' '}
        {GeraDiaDaSemana(diaSemana)}
      </p>
    )}
    {(enderecoDe) && (
    <p>
      <span style={{ fontWeight: 'bolder' }}>Endereço De:</span>
        {' '}
      {enderecoDe}
    </p>
    )}
    {(enderecoAte) && (
    <p>
      <span style={{ fontWeight: 'bolder' }}>Endereço Até:</span>
        {' '}
      {enderecoAte}
    </p>
    )}
    {(horario) && (
    <p>
      <span style={{ fontWeight: 'bolder' }}>Horário:</span>
        {' '}
      {horario}
    </p>
    )}
    {(html) && (
    <p>
      <span style={{ fontWeight: 'bolder' }}>Itinerário:</span>
        {' '}
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </p>
    )}
  </div>
);

CardColetaDeLixo.propTypes = {
  diaSemana: PropTypes.string,
  enderecoAte: PropTypes.string,
  enderecoDe: PropTypes.string,
  horario: PropTypes.string,
  html: PropTypes.string,
};

CardColetaDeLixo.defaultProps = {
  diaSemana: '',
  enderecoAte: '',
  enderecoDe: '',
  horario: '',
  html: '',
};

export default CardColetaDeLixo;
